import type { I18n, MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { errorStatus, errorToastText } from '@/lib/translateBackendError';

/**
 * A state transition (finalise, pause, resume, confirm a termination...) that
 * answers 404 or 409 lost a race: a colleague or a background job moved the
 * record first. The generic "failed" toast reads like a fault; the user only
 * has to look at the refreshed record.
 */
export const alreadyHandledMessage: MessageDescriptor = msg({
  id: 'billing.error.alreadyHandled',
  message: 'Already handled. Someone else changed this in the meantime. The current state has been loaded.',
});

export function isAlreadyHandledError(error: unknown): boolean {
  const status = errorStatus(error);
  return status === 404 || status === 409;
}

/**
 * Toast text for a failed transition: the "Already handled" wording on a lost
 * race (404/409), otherwise the regular backend text or the fallback.
 */
export function transitionErrorText(
  error: unknown,
  i18n: I18n,
  fallback: MessageDescriptor | string,
): string {
  if (isAlreadyHandledError(error)) return i18n._(alreadyHandledMessage);
  return errorToastText(error, i18n, fallback);
}
